<template>
  <div>
    <v-container v-if="isSuperadmin() || isAdmin()" fluid class="pa-0">
      <v-layout class="column avatar-info" align-center justify-center>
        <v-flex xs12 sm6 class="py-2">
          <v-btn-toggle v-model="selectedTool" mandatory>
            <v-btn flat>
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn flat>
              <v-icon>block</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-spacer></v-spacer>
    <vue-calendar
      ref="calendar"
      :config="config"
      :events="events"
      @event-click="eventClick"
      @select="select"
    ></vue-calendar>
  </div>
</template>

<script>
  'use strict'

  import moment from 'moment'
  import VueCalendar from '@/components/vue-calendar'
  export default {

    name: 'Calendar',

    components: {
      VueCalendar
    },

    data: () => ({
      events: [],
      config: {
        buttonText: {
          today: 'hoy',
          month: 'mes',
          week: 'semana',
          day: 'día',
          list: 'lista'
        },
        allDayText: 'todo el día',
        allDaySlot: false,
        scrollTime: '08:00:00',
        defaultView: 'month',
        editable: false,
        selectable: true,
        droppable: false,
        locale: 'es',
        hiddenDays: [0]
      },
      selected: {},
      deactivatedShedules: [],
      shedules: [],
      startDate: '',
      endDate: '',
      humanizeDate: '',
      selectedTool: 0
    }),

    created () {
      this.getDeactivatedShedules().then((response) => {
        this.getBookings(this.$store.getters['api/getUserRol']).then((response) => {
        }).catch((error) => {
          console.log(error)
          this.$store.dispatch(
            'snackbar/show',
            'Error al obtener las reservas: ' + this.$store.getters['api/getMessage']
          )
        })
      }).catch((error) => {
        console.log(error)
        this.$store.dispatch(
          'snackbar/show',
          'Error al obtener los días ocupados: ' + this.$store.getters['api/getMessage']
        )
      })
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isSuperadmin () {
        return this.$store.getters['api/getUserRol'] === 'superadmin'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isAdmin () {
        return this.$store.getters['api/getUserRol'] === 'administrator'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isCommerce () {
        return this.$store.getters['api/getUserRol'] === 'commerce'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      isInstaller () {
        return this.$store.getters['api/getUserRol'] === 'installer'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      eventClick (event) {
        if (this.isInstaller() || (this.isSuperadmin() || this.isAdmin())) {
          this.eventClickInstaller(event)
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      eventClickInstaller (event) {
        if (event.status === 12) {
          this.deleteDeactivatedShedule(event)
        } else {
          this.openBooking(event.identificator)
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openBooking (saleID) {
        this.$router.push({
          name: 'booking-id',
          params: {
            booking_id: saleID
          }
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      newBooking () {
        this.$router.push({
          name: 'booking-id',
          params: {
            booking_id: 'new',
            booking_start: moment(this.startDate).format('YYYY-MM-DD_HH:mm:ss'),
            booking_end: moment(this.endDate).format('YYYY-MM-DD_HH:mm:ss')

          }
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      humanize (startDate, endDate) {
        return 'Desde el ' + moment(this.startDate).format('DD-MM-YYYY') + ' a las ' + moment(this.startDate).format('HH:mm') + ' hasta el ' + moment(this.endDate).format('DD-MM-YYYY') + ' a las ' + moment(this.endDate).format('HH:mm') + '.'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      select (startDate, endDate) {
        this.startDate = startDate
        this.endDate = endDate
        this.humanizeDate = this.humanize()
        if (this.isInstaller()) {
          this.addDeactivatedShedule()
        } else if ((this.isSuperadmin() || this.isAdmin())) {
          if (this.selectedTool === 0) {
            this.newBooking()
          } else if (this.selectedTool === 1) {
            this.addDeactivatedShedule()
          }
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getColorByState (status) {
        status = parseInt(status)
        let color = ''
        switch (status) {
          case 6:
            color = '#3f51b5'
            break
          case 7:
            color = '#673ab7'
            break
          case 8:
            color = '#f44336'
            break
          case 9:
            color = '#ff9800'
            break
          case 10:
            color = '#009688'
            break
          case 11:
            color = '#00897b'
            break
          case 12:
            color = '#9e9e9e'
            break
          case 13:
            color = '#2196f3'
            break
        }
        return color
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getStatusName (status) {
        status = parseInt(status)
        let text = ''
        switch (status) {
          case 6:
            text = 'Pendiente'
            break
          case 7:
            text = 'En proceso'
            break
          case 8:
            text = 'Cancelada'
            break
          case 9:
            text = 'Anulada'
            break
          case 10:
            text = 'Finalizada'
            break
          case 11:
            text = 'Finalizada'
            break
          case 12:
            text = 'Ocupado'
            break
          case 13:
            text = 'Cita programada'
            break
        }
        return text
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      renderShedules (element) {
        if (element.items) {
          element.items.forEach((item, index) => {
            this.$refs.calendar.renderEvent({
              id: Date.now(),
              identificator: item[element.item_value],
              status: item[element.item_text_3] || 12,
              title: this.getStatusName(item[element.item_text_3] || 12),
              start: item[element.item_text],
              end: item[element.item_text_2],
              overlap: true,
              color: this.getColorByState(item[element.item_text_3] || 12)
            }, true)
          })
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getBookings (type) {
        return new Promise((resolve, reject) => {
          let userID = parseInt(this.$store.getters['api/getUserId'])
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'bookings/' + userID + '/' + type + '/'
          }).then((response) => {
            this.shedules = response.data
            this.renderShedules(this.shedules)
            // console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener calendario: ' + this.$store.getters['api/getMessage']
            )
            reject(error)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getDeactivatedShedules () {
        return new Promise((resolve, reject) => {
          let userID = parseInt(this.$store.getters['api/getUserId'])
          // console.log(userID)
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'deactivated-shedules/' + userID + '/'
          }).then((response) => {
            this.deactivatedShedules = response.data
            this.renderShedules(this.deactivatedShedules)
            // console.log(response)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener calendario: ' + this.$store.getters['api/getMessage']
            )
            reject(error)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addDeactivatedShedule () {
        this.dialog = false
        let userID = parseInt(this.$store.getters['api/getUserId'])
        this.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'deactivated-shedules/' + userID + '/',
          data: {
            start: moment(this.startDate).format('YYYY-MM-DD HH:mm:ss'),
            end: moment(this.endDate).format('YYYY-MM-DD HH:mm:ss')
          }
        }).then((response) => {
          // console.log(response.data)
          let event = {
            id: Date.now(),
            identificator: response.data,
            status: 12,
            title: this.getStatusName(12),
            start: this.startDate,
            end: this.endDate,
            overlap: true,
            color: this.getColorByState(12)
          }
          this.$refs.calendar.renderEvent(event, true)
          this.$awn.success('Horario agregado')
        }).catch((error) => {
          console.log(error)
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al agregar observación: ' + message)
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteDeactivatedShedule (event) {
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'deactivated-shedules/' + event.identificator + '/'
        }).then((response) => {
          // console.log(response)
          this.$refs.calendar.removeEvent(event)
          this.$awn.success('Horario eliminado')
        }).catch(() => {
          let message = this.$store.getters['api/getMessage']
          this.$awn.alert('Error al eliminar el horario: ' + message)
        })
      }
    },
    computed: {
      eventSources () {
      }
    }
  }
</script>


<style lang="sass">

$subtract: 'http://localhost:8088/app/public/subtract-icon.png'

$add: 'http://localhost:8088/app/public/add-icon.png'

$disable: 'http://localhost:8088/app/public/disable-icon.png'

.fc-sun
  background: #eee

.vc-icon
  height: 24px
  width: 24px

.add
  background-image: url($add)

.subtract
  background-image: url($subtract)

.disable
  background-image: url($disable)

.fc-view-container
  // cursor: url($subtract), auto
</style>


// WEBPACK FOOTER //
// src/pages/calendar.vue